export default "__VITE_ASSET__C_XsRL8t__"